import {useState} from 'react'

import './index.css'

import Popup from 'reactjs-popup'

import 'reactjs-popup/dist/index.css'

const PaymentPopup = () => {
  const [selectedPayment, setSelectedPayment] = useState('')
  const confirmOrder = () => {
    console.log('success')
  }
  const className =
    selectedPayment === 'CashOnDelivery'
      ? 'confirm-order-button'
      : 'deactivated-order-button'
  return (
    <>
      <div className="orderPlacementContianer">
        <div className="paymentMethodRadioButtonContainer">
          <input
            id="cardButton"
            type="radio"
            className="paymentMethodRadioButton"
            value="card"
            name="paymentMethod"
            onChange={e => setSelectedPayment(e.target.value)}
            disabled
          />
          <label htmlFor="cardButton"> Card</label>
        </div>
        <div className="paymentMethodRadioButtonContainer">
          <input
            id="NetBankingButton"
            type="radio"
            className="paymentMethodRadioButton"
            value="NetBanking"
            name="paymentMethod"
            onChange={e => setSelectedPayment(e.target.value)}
            disabled
          />
          <label htmlFor="NetBankingButton"> Net Banking</label>
        </div>
        <div className="paymentMethodRadioButtonContainer">
          <input
            id="UPIButton"
            type="radio"
            className="paymentMethodRadioButton"
            value="UPI"
            name="paymentMethod"
            onChange={e => setSelectedPayment(e.target.value)}
            disabled
          />
          <label htmlFor="UPIButton"> UPI</label>
        </div>
        <div className="paymentMethodRadioButtonContainer">
          <input
            id="walletButton"
            type="radio"
            className="paymentMethodRadioButton"
            value="Wallet"
            name="paymentMethod"
            onChange={e => setSelectedPayment(e.target.value)}
            disabled
          />
          <label htmlFor="walletButton"> Wallet</label>
        </div>
        <div className="paymentMethodRadioButtonContainer">
          <input
            id="cashOnDeliveryButton"
            type="radio"
            className="paymentMethodRadioButton"
            value="CashOnDelivery"
            name="paymentMethod"
            onChange={e => setSelectedPayment(e.target.value)}
          />
          <label htmlFor="cashOnDeliveryButton"> Cash on Delivery</label>
        </div>

        <Popup
          trigger={
            <button
              type="button"
              className={className}
              onClick={confirmOrder}
              disabled={selectedPayment !== 'CashOnDelivery'}
            >
              Confirm Order
            </button>
          }
        >
          <div>
            <p>Your order has been placed successfully</p>
          </div>
        </Popup>
      </div>
    </>
  )
}

export default PaymentPopup
